import React from 'react';
import PropTypes from 'prop-types';

import { formatExpirationDate, renderDate } from '../dateHelpers';

const ExpirationDateUpdateCellRender = ({ value, data, isEdited }) => {
  const editedStyle = isEdited && isEdited(data.id) ? 'edited-color' : '';

  return value
    ? <div className={editedStyle}>{renderDate(formatExpirationDate(value))}</div>
    : null;
};

ExpirationDateUpdateCellRender.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  isEdited: PropTypes.func,
};

export default () => props => <ExpirationDateUpdateCellRender {...props} />; // eslint-disable-line react/display-name
